const HEX_LENGTH = 7

export function calculateAlphaHex(input: string) {
  const scaled = Math.round((Number(input) / 100) * 255)
  return scaled.toString(16).padStart(2, '0').toUpperCase()
}

export function getRegularHexPart(input?: string) {
  if (!input) return
  if (input.length === HEX_LENGTH) return input
  return input.toString().slice(0, 7)
}

export function calculatePercentageFromHex(input: string) {
  if (!input.length) return '100'
  return String(Math.round((parseInt(input, 16) / 255) * 100))
}
